<main class="main-content">
  <div>
    <div class="bg-brand-purple-50 p-8">
      <div class="flex items-center justify-between">
        <h2 class="page-title">Meus dados</h2>
      </div>
    </div>
    <div class="main-content__area">
      <div class="mb-5 row">
        <div class="col-12 col-lg-5">
          <h2 class="content-block-title">
            <span class="rounded-icon" medium style="background-color: white">
              <span class="material-symbols-outlined filled">
                folder_shared
              </span>
            </span>
            Informações pessoais
          </h2>
        </div>
        <div class="col-12 col-lg-7">
          <form
            [formGroup]="dadosPessoaisForm"
            (ngSubmit)="atualizarDadosPessoais()"
          >
            <div class="row">
              <input type="hidden" formControlName="idUsuario" />

              <div class="mb-4 col-12">
                <input
                  type="email"
                  formControlName="email"
                  placeholder="E-mail"
                  class="form-control form-control-lg"
                  (input)="onInputEmail($event)"
                  required
                />
              </div>

              <div class="mb-4 col-6">
                <input
                  type="text"
                  formControlName="login"
                  placeholder="Login"
                  class="form-control form-control-lg"
                  required
                />
              </div>

              <div class="mb-4 col-6">
                <input
                  type="text"
                  formControlName="nome"
                  placeholder="Nome"
                  class="form-control form-control-lg"
                  required
                />
              </div>

              <div class="col-12 text-end">
                <button
                  type="submit"
                  class="btn btn-primary"
                  [disabled]="salvandoDados"
                >
                  <span
                    *ngIf="salvandoDados"
                    class="spinner-border spinner-border-sm me-1"
                    role="status"
                    aria-hidden="true"
                  ></span>
                  Atualizar dados
                </button>
              </div>
            </div>
          </form>
        </div>
      </div>

      <div class="row">
        <div class="col-12 col-lg-5">
          <h2 class="content-block-title">
            <span class="rounded-icon" medium style="background-color: white">
              <span class="material-symbols-outlined filled"> key </span>
            </span>
            Alterar senha
          </h2>
        </div>
        <div class="col-12 col-lg-7">
          <form [formGroup]="senhaForm" (ngSubmit)="atualizarSenha()">
            <div class="row">
              <div class="mb-4 col-12">
                <div class="input-container">
                  <input
                    [type]="mostrarSenhaAtual ? 'text' : 'password'"
                    formControlName="senhaAtual"
                    placeholder="Senha atual"
                    class="form-control form-control-lg"
                    required
                  />
                  <button
                    type="button"
                    class="toggle-password"
                    (click)="toggleVisibilidadeSenha('atual')"
                  >
                    <span class="material-symbols-outlined">
                      {{ mostrarSenhaAtual ? "visibility_off" : "visibility" }}
                    </span>
                  </button>
                </div>
              </div>

              <div class="mb-4 col-6">
                <div class="input-container">
                  <input
                    [type]="mostrarNovaSenha ? 'text' : 'password'"
                    formControlName="novaSenha"
                    placeholder="Nova senha"
                    class="form-control form-control-lg"
                    required
                  />
                  <button
                    type="button"
                    class="toggle-password"
                    (click)="toggleVisibilidadeSenha('nova')"
                  >
                    <span class="material-symbols-outlined">
                      {{ mostrarNovaSenha ? "visibility_off" : "visibility" }}
                    </span>
                  </button>
                  <span class="password-info-icon" #senhaInfo>?</span>
                </div>
              </div>

              <div class="mb-4 col-6">
                <div class="input-container">
                  <input
                    [type]="mostrarConfirmarSenha ? 'text' : 'password'"
                    formControlName="confirmarSenha"
                    placeholder="Repetir nova senha"
                    class="form-control form-control-lg"
                    required
                  />
                  <button
                    type="button"
                    class="toggle-password"
                    (click)="toggleVisibilidadeSenha('confirmar')"
                  >
                    <span class="material-symbols-outlined">
                      {{
                        mostrarConfirmarSenha ? "visibility_off" : "visibility"
                      }}
                    </span>
                  </button>
                </div>
              </div>

              <div class="col-12 text-end">
                <button
                  type="submit"
                  class="btn btn-primary"
                  [disabled]="alterandoSenha"
                >
                  <span
                    *ngIf="alterandoSenha"
                    class="spinner-border spinner-border-sm me-1"
                    role="status"
                    aria-hidden="true"
                  ></span>
                  Atualizar senha
                </button>
              </div>
            </div>
          </form>
        </div>
      </div>
    </div>
  </div>
</main>
